var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import useResize from "../services/resize.js";
import { isDev } from "../utils/index.js";
function testBreakpoints(instance, breakpoint = useResize().props().breakpoint) {
  const { activeBreakpoints, inactiveBreakpoints } = instance.$options;
  const isInActiveBreakpoint = activeBreakpoints && activeBreakpoints.split(" ").includes(breakpoint);
  const isInInactiveBreakpoint = inactiveBreakpoints && inactiveBreakpoints.split(" ").includes(breakpoint);
  if (activeBreakpoints && isInActiveBreakpoint || inactiveBreakpoints && !isInInactiveBreakpoint) {
    return "$mount";
  }
  return "$destroy";
}
function hasBreakpointConfiguration(instance) {
  const { activeBreakpoints, inactiveBreakpoints } = instance.$options;
  return Boolean(activeBreakpoints || inactiveBreakpoints);
}
function testConflictingBreakpointConfiguration(instance) {
  const { activeBreakpoints, inactiveBreakpoints, name } = instance.$options;
  if (activeBreakpoints && inactiveBreakpoints) {
    throw new Error(`[${name}] Incorrect configuration: the \`activeBreakpoints\` and \`inactiveBreakpoints\` are not compatible.`);
  }
}
function addToResize(key, instance) {
  if (isDev) {
    testConflictingBreakpointConfiguration(instance);
  }
  const { add, has } = useResize();
  if (!has(key)) {
    add(key, function onResize({ breakpoint }) {
      const action = testBreakpoints(instance, breakpoint);
      if (action === "$destroy" && instance.$isMounted) {
        instance[action]();
      } else if (action === "$mount" && !instance.$isMounted) {
        setTimeout(() => instance[action](), 0);
      }
    });
  }
}
function withBreakpointObserver(BaseClass) {
  var _a, _b;
  return _b = class extends BaseClass {
    constructor(element) {
      super(element);
      const { remove, props } = useResize();
      const { name } = this.$options;
      if (!props().breakpoint) {
        if (isDev) {
          throw new Error(`[${name}] The \`BreakpointObserver\` class requires breakpoints to be defined.`);
        }
        return;
      }
      const key = `BreakpointObserver-${this.$id}`;
      const mutationObserver = new MutationObserver(([mutation]) => {
        if (mutation.type === "attributes" && (mutation.attributeName === "data-options" || mutation.attributeName.startsWith("data-option-"))) {
          if (!hasBreakpointConfiguration(this)) {
            this.$mount();
            remove(key);
            return;
          }
          addToResize(key, this);
        }
      });
      mutationObserver.observe(this.$el, { attributes: true });
      if (!hasBreakpointConfiguration(this)) {
        return;
      }
      addToResize(key, this);
    }
    $mount() {
      if (!hasBreakpointConfiguration(this)) {
        return super.$mount();
      }
      const action = testBreakpoints(this);
      if (action === "$mount") {
        return super.$mount();
      }
      return this;
    }
  }, __publicField(_b, "config", {
    ...BaseClass.config,
    name: `${BaseClass.config.name}WithBreakpointObserver`,
    options: {
      ...((_a = BaseClass.config) == null ? void 0 : _a.options) || {},
      activeBreakpoints: String,
      inactiveBreakpoints: String
    }
  }), _b;
}
export {
  withBreakpointObserver as default
};
